import React from 'react';
import moment from 'moment';

const DateRange = ({ params }) => {
    const value = params?.value;

    if (!value) {
        return <></>;
    }

    return (
        <span>
            {moment(value.fromDate).format('L')} - {moment(value.toDate).format('L')}
        </span>
    );
};

export default DateRange;
